import { SVGProps, useId } from "react";

type LocationIconProps = SVGProps<SVGSVGElement> & {
  useGradient?: boolean;
};

export default function LocationIcon(props: LocationIconProps) {
  const {
    height = 20,
    width = 20,
    stroke = "#4B5563",
    useGradient = true,
    ...rest
  } = props;
  const id = useId();
  const iconStroke = useGradient ? `url(#paint0_${id})` : stroke;
  const pinStroke = useGradient ? `url(#paint1_${id})` : stroke;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        opacity="0.4"
        d="M9.9999 11.1912C11.4358 11.1912 12.5999 10.0272 12.5999 8.59121C12.5999 7.15527 11.4358 5.99121 9.9999 5.99121C8.56396 5.99121 7.3999 7.15527 7.3999 8.59121C7.3999 10.0272 8.56396 11.1912 9.9999 11.1912Z"
        stroke={iconStroke}
        strokeWidth="1.5"
      />
      <path
        d="M3.01626 7.07533C4.65793 -0.141339 15.3496 -0.133006 16.9829 7.08366C17.9413 11.317 15.3079 14.9003 12.9996 17.117C11.3246 18.7337 8.6746 18.7337 6.99126 17.117C4.69126 14.9003 2.05793 11.3087 3.01626 7.07533Z"
        stroke={pinStroke}
        strokeWidth="1.5"
      />
      {useGradient && (
        <defs>
          <linearGradient
            id={`paint0_${id}`}
            x1="9.9999"
            y1="5.99121"
            x2="9.9999"
            y2="11.1912"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F56F10" />
            <stop offset="1" stopColor="#F52310" />
          </linearGradient>
          <linearGradient
            id={`paint1_${id}`}
            x1="9.99958"
            y1="1.66699"
            x2="9.99958"
            y2="18.3295"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F56F10" />
            <stop offset="1" stopColor="#F52310" />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
}
